// extracted by mini-css-extract-plugin
module.exports = {"legendItem":"style_legendItem__160CX","collapse":"style_collapse__ddnRK","removeButton":"style_removeButton__1ceP2"};